import { render, staticRenderFns } from "./NovedadesHome.vue?vue&type=template&id=6cab384e&"
import script from "./NovedadesHome.vue?vue&type=script&lang=js&"
export * from "./NovedadesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports